export function randomNumber (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function groupBy (array) {
  return array.reduce((r, k) => {
    r[k] = 1 + r[k] || 1
    return r
  }, {})
}

export function getCollectionsByLanguage (language) {
  switch (language) {
    case 'en':
      return [
        { text: 'Plastic Pollution', value: 'plastic_pollution' },
        { text: 'General Terms', value: 'terms' },
        { text: 'Innovations', value: 'innovations' },
        { text: 'Machines', value: 'machines' },
        { text: 'Products', value: 'products' },
        { text: 'Processes', value: 'processes' }
      ]
    case 'de':
      return [
        { text: 'General Terms', value: 'terms' },
        { text: 'Innovations', value: 'innovations' },
        { text: 'Machines', value: 'machines' },
        { text: 'Products', value: 'products' },
        { text: 'Processes', value: 'processes' }
      ]
    case 'nl': {
      return [
        { text: 'General Terms', value: 'terms' },
        { text: 'Innovations', value: 'innovations' },
        { text: 'Machines', value: 'machines' },
        { text: 'Products', value: 'products' },
        { text: 'Processes', value: 'processes' }
      ]
    }
    case 'el':
      return [
        { text: 'General Terms', value: 'terms' },
        { text: 'Innovations', value: 'innovations' },
        { text: 'Machines', value: 'machines' },
        { text: 'Products', value: 'products' },
        { text: 'Processes', value: 'processes' }
      ]
    default:
      console.error('no collection found for this language!')
  }
}

export function getRandomArrayIndex (array) {
  return array[Math.floor(Math.random() * array.length)]
}

export function convertRange (value, r1, r2) {
  return (value - r1[0]) * (r2[1] - r2[0]) / (r1[1] - r1[0]) + r2[0]
}
